// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__17rMT","footer":"ChangeClinic_footer__1-m7Y"};